// src/components/ScheduailerPage.js
import React, { useState } from 'react'; // NEW: Import useState
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; // NEW: Import AnimatePresence
import { FaBolt, FaMagic, FaDesktop, FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // NEW: Import arrow icons

const featuresData = [
  { 
    icon: <FaBolt />, 
    title: "Disponibilitate 24/7", 
    text: "Permite clienților să-și facă programări direct pe WhatsApp, zi și noapte, fără nicio intervenție din partea ta. Asistentul AI gestionează conversația și confirmă totul automat." 
  },
  { 
    icon: <FaMagic />, 
    title: "Sugestii Inteligente", 
    text: "Dacă ora solicitată este ocupată, AI-ul nu spune doar 'Nu'. Propune inteligent următorul interval liber, transformând un refuz într-o nouă oportunitate de programare." 
  },
  { 
    icon: <FaDesktop />, 
    title: "Control Total din Dashboard", 
    text: "Definește-ți propriile reguli. Setează programul de lucru, serviciile oferite și regulile de booking printr-un panou de control simplu și intuitiv. AI-ul se va conforma 100% afacerii tale." 
  }
];

// FIXED: Corrected the image paths using template literals
const screenshots = [
  `${process.env.PUBLIC_URL}/screenshots/1.png`,
  `${process.env.PUBLIC_URL}/screenshots/2.png`,
  `${process.env.PUBLIC_URL}/screenshots/3.png`,
  `${process.env.PUBLIC_URL}/screenshots/4.png`
];

// NEW: Variants for the image slide animation
const slideVariants = {
  enter: (direction) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};


function ScheduailerPage() {
  // NEW: State to track the current image index and animation direction
  const [[page, direction], setPage] = useState([0, 0]);

  // NEW: Function to handle changing the image
  const paginate = (newDirection) => {
    // This logic ensures the slider loops around
    const newIndex = (page + newDirection + screenshots.length) % screenshots.length;
    setPage([newIndex, newDirection]);
  };
  
  return (
    <motion.div 
      className="page-container-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* 1. HERO SECTION (Unchanged) */}
      <div className="scheduailer-hero">
        <motion.h1 className="scheduailer-title" initial={{ opacity: 0, y: -30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
          ScheduAIler
        </motion.h1>
        <motion.p className="scheduailer-subtitle" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }}>
Transformă WhatsApp-ul în cel mai eficient angajat al tău. Programări automate, clienți fericiți.
        </motion.p>
      </div>
 {/* 4. FEATURES SECTION (Unchanged) */}
      <div className="scheduailer-section">
        <div className="scheduailer-features-grid">
          {featuresData.map((feature, index) => (
            <motion.div className="feature-card" key={index} initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.2 }}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* 2. VIDEO SHOWCASE (Unchanged) */}
      <motion.h2 className="gallery-title" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>Prezentare video</motion.h2>
      <motion.div className="scheduailer-section" initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.6 }}>
        <div className="scheduailer-media-frame">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/dQw4w9WgXdQ?autoplay=0&controls=1&modestbranding=1&rel=0"
            title="ScheduAIler Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: '6px' }}
          ></iframe>
        </div>
      </motion.div>
        {/* 5. REBUILT: SCREENSHOT GALLERY SLIDER */}
      <div className="gallery-section">
        <motion.h2 className="gallery-title" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>Galerie de Imagini</motion.h2>
        
        {/* NEW: This is the container for our slider */}
        <motion.div className="gallery-slider-container">
          <AnimatePresence initial={false} custom={direction}>
            <motion.img
              key={page} // Key is crucial for AnimatePresence to detect changes
              src={screenshots[page]}
              alt={`Screenshot ${page + 1}`}
              custom={direction}
              variants={slideVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                x: { type: "spring", stiffness: 300, damping: 30 },
                opacity: { duration: 0.2 }
              }}
              className="gallery-slider-image"
            />
          </AnimatePresence>

          {/* NEW: Navigation Buttons */}
          <div className="gallery-next" onClick={() => paginate(1)}>
            <FaArrowRight />
          </div>
          <div className="gallery-prev" onClick={() => paginate(-1)}>
            <FaArrowLeft />
          </div>
        </motion.div>
      </div>
      
      {/* 3. LIVE DEMO CTA (Unchanged) */}
      <motion.div className="scheduailer-section" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        <div className="demo-cta-container">
            <FaDesktop className="demo-cta-icon" />
            <h2>Experimentează Platforma</h2>
            <p>Interacționează cu o versiune demonstrativă complet funcțională a panoului de control.</p>
            <Link to="/scheduailer/demo" className="cta-button demo-button">
                Pornește Demo-ul Interactiv
            </Link>
        </div>
      </motion.div>

     
    
      <Link to="/" className="cta-button" style={{ marginTop: '60px' }}>
        ← Înapoi la pagina principală
      </Link>
    </motion.div>
  );
}

export default ScheduailerPage;